import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';

export const CONSENTS = {
  marketing: (
    <>
      (optional) Ja, ich willige ein, dass mich die verbundenen{' '}
      <TextCTA as="a" href="/lichtblick-gruppe/" inlineLink target="_blank">
        Unternehmen der LichtBlick Gruppe
      </TextCTA>{' '}
      über Strom-, E-Mobilitäts- und Gas-Produkte sowie über energienahe Produkte und Dienstleistungen (z.B. Smartmeter,
      Wallboxen, alternative Energieanlagen oder Energieberatung) sowie zu Marktforschungszwecken und zur
      Qualitätssicherung telefonisch oder per E-Mail kontaktieren und informieren.
    </>
  ),
  privacyPolicy: (
    <>
      Ich habe die{' '}
      <TextCTA as="a" href="/datenschutz/" inlineLink target="_blank">
        Datenschutzhinweise
      </TextCTA>{' '}
      zur Kenntnis genommen und bin darüber informiert, dass die vorstehende, freiwillige Einwilligung jederzeit ohne
      Angabe von Gründen mit Wirkung für die Zukunft (per Post an LichtBlick&nbsp;SE, Klostertor&nbsp;1,
      20097&nbsp;Hamburg oder per E-Mail an{' '}
      <TextCTA as="a" href="mailto:datenschutz@lichtblick.de" inlineLink>
        datenschutz@lichtblick.de
      </TextCTA>
      ) widerrufen werden kann.
    </>
  ),
} as const;
